import { ButtonProps } from '@almbrand/button';
import classNames from 'classnames';
import { useAppDispatch } from 'store/hooks';
import { setModal } from 'store/slices/modalSlice';
import { replacePlaceholdersModal } from '../services/PlaceholderService';

type ActionButtonProps = {
	title: string;
	type?: ButtonProps['buttonType'];
	//onClick?: () => void;
};

const getReplaceTokens = (title: string, subtitle: string, content: string) => {
	const replaceTokens = {
		title,
		subtitle,
		content,
		contentType: 'ModalContentBlock',
	};
	replacePlaceholdersModal(replaceTokens);
	return replaceTokens;
};
export const useModal = () => {
	const dispatch = useAppDispatch();

	const displayErrorModal = (title: string, subtitle: string, content: string, fields?: any[]) => {
		if (title) {
			const replaceTokens = getReplaceTokens(title, subtitle, content);
			dispatch(
				setModal({
					displayModal: true,
					modalProps: {
						title: replaceTokens.title,
						subtitle: replaceTokens.subtitle,
						fields,
						content: replaceTokens.content,
						isErrorModal: true,
					},
				})
			);
		}
	};

	const displayModal = (
		title: string,
		subtitle: string,
		content: string,
		fields?: any[],
		actionButtonProps?: ActionButtonProps,
		className?: string
	) => {
		if (title) {
			const replaceTokens = getReplaceTokens(title, subtitle, content);

			dispatch(
				setModal({
					displayModal: true,
					modalProps: {
						title: replaceTokens.title,
						subtitle: replaceTokens.subtitle,
						content: replaceTokens.content,
						fields,
						actionButtonProps: actionButtonProps
							? {
									title: actionButtonProps.title,
									type: actionButtonProps.type,
									// do NOT include onClick here
								}
							: undefined,
						className: className ? classNames(className) : undefined,
					},
				})
			);
		}
	};

	return { displayErrorModal, displayModal };
};
